module.exports = __webpack_public_path__ + "static/img/screenshot-bg.fe205e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot-bg.png
// module id = 8bdc
// module chunks = 0